import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import routes from '../../../../components/Routes/routingMap';
import useFields from './hooks/useFields';
import RegisterTicketView from './RegisterTicketView';
import { Creators as ProceduresNotAutomatedActions } from '../../../../../domain/useCases/procedures/registerTicket/getProceduresNotAutomated';
import { Creators as RegisterTicketActions } from '../../../../../domain/useCases/procedures/registerTicket/registerTicketNotAutomated';
import XCheckpointManager from '../../../../../core/managers/xcheckpointManager';
import useProfile from '@/presentation/hooks/useProfile';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const RegisterTicketController = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { academic } = useProfile();
  const { search } = useLocation();
  const idParam = new URLSearchParams(search).get('v');

  const [showConfirmCancel, setShowConfirmCancel] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const [loadSendTicket, setLoadSendTicket] = React.useState(false);
  const {
    fields,
    errors,
    formIsValid,
    formIsEditing,
    setFieldValue,
    setFieldError
  } = useFields();

  const handlerBackButton = () => {
    if (formIsEditing) {
      setShowConfirmCancel(true);
    } else {
      history.push(routes.student.procedures.home);
    }
  };
  const handlerBackButtonConfirm = () => {
    history.push(routes.student.procedures.home);
  };
  const handlerBackButtonCancel = () => {
    setShowConfirmCancel(false);
  };

  const { isLoading: isLoadingData, data: proceduresList } = useSelector(
    (state: any) => state.proceduresNotAutomated
  );
  React.useEffect(() => {
    GoogleAnalytics.writeLog('portal-procedure-registerTicket', 'portal');
    if (!proceduresList || proceduresList?.length === 0)
      dispatch(ProceduresNotAutomatedActions.getProceduresNotAutomated());
    dispatch(RegisterTicketActions.registerTicketClear());
  }, []);

  React.useEffect(() => {
    if (proceduresList && idParam) {
      const procedureFound = proceduresList.find((p: any) => p.id === idParam);
      setSelectedItem(procedureFound);

      setFieldValue({ name: 'procedureId', value: procedureFound?.id });
    }
  }, [proceduresList]);

  const { isLoading: isLoadingTicket } = useSelector(
    (state: any) => state.registerTicket
  );

  const registerTicket = () => {
    GoogleAnalytics.writeLog(
      `portal-procedure-registerTicketRequest`,
      'portal'
    );
    if (formIsValid) {
      XCheckpointManager.registerStart('Ticketera');
      dispatch(
        RegisterTicketActions.registerTicket({
          ...fields,
          acadProg: academic.prog
        })
      );
      setLoadSendTicket(true);
    }
  };
  const clearError = () => {
    dispatch(RegisterTicketActions.registerTicketErrorClear());
  };

  useEffect(() => {
    if (!isLoadingTicket && loadSendTicket) {
      XCheckpointManager.registerEnd('Ticketera');
      setLoadSendTicket(false);
    }
  }, [isLoadingTicket]);

  const {
    isLoading: isLoadingRegister,
    isSuccess,
    error
  } = useSelector((state: any) => state.registerTicket);
  return (
    <RegisterTicketView
      fields={fields}
      errors={errors}
      setFieldValue={setFieldValue}
      setFieldError={setFieldError}
      formIsValid={formIsValid}
      showConfirmCancel={showConfirmCancel}
      handlerBackButton={handlerBackButton}
      handlerBackButtonConfirm={handlerBackButtonConfirm}
      handlerBackButtonCancel={handlerBackButtonCancel}
      isLoadingData={isLoadingData}
      proceduresList={proceduresList}
      isLoadingRegister={isLoadingRegister}
      isSuccess={isSuccess}
      registerTicket={registerTicket}
      error={error}
      clearError={clearError}
      selectedItem={selectedItem}
    />
  );
};

export default RegisterTicketController;
